
import React from 'react';
import { HashRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { ScrollToTop } from './components/shared/ScrollToTop';
import { FloatingScrollTop } from './components/shared/FloatingScrollTop'; // Importazione
import { PageTransition } from './components/shared/PageTransition';
import { ChatBot } from './components/shared/ChatBot';
import { CookieConsent } from './components/shared/CookieConsent';
import { HomePage } from './pages/HomePage';
import { FinancePage } from './pages/FinancePage';
import { BlueStrikePage } from './pages/BlueStrikePage';
import { BlueStrikeDashboardPage } from './pages/BlueStrikeDashboardPage';
import { AlgoEnginePage } from './pages/AlgoEnginePage';
import { CopyServicePage } from './pages/CopyServicePage';
import { RealEstatePage } from './pages/RealEstatePage';
import { TokenPage } from './pages/TokenPage';
import { CorporateInfoPage } from './pages/CorporateInfoPage';
import { WhitepaperPage } from './pages/WhitepaperPage';
import { AiAutomationPage } from './pages/AiAutomationPage';
import { AlgoEngineDashboardPage } from './pages/AlgoEngineDashboardPage';
import { LinktreePage } from './pages/LinktreePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { ROUTES } from './constants';

function AppContent() {
  const location = useLocation();
  const isLinktreePage = location.pathname === ROUTES.LINKTREE;

  return (
    <>
      <ScrollToTop />
      <PageTransition />
      {!isLinktreePage && <ChatBot />}
      <CookieConsent />
      {!isLinktreePage && <FloatingScrollTop />}
      <div className="flex flex-col min-h-screen font-sans transition-colors duration-300">
        {!isLinktreePage && <Navbar />}
        <main className="flex-grow">
          <Routes>
            <Route path={ROUTES.HOME} element={<HomePage />} />
            <Route path={ROUTES.FINANCE} element={<FinancePage />} />
            <Route path={ROUTES.BLUE_STRIKE} element={<BlueStrikePage />} />
            <Route path={ROUTES.BLUE_STRIKE_DASHBOARD} element={<BlueStrikeDashboardPage />} />
            <Route path={ROUTES.ALGO_ENGINE} element={<AlgoEnginePage />} />
            <Route path={ROUTES.COPY_SERVICE} element={<CopyServicePage />} />
            <Route path={ROUTES.REAL_ESTATE} element={<RealEstatePage />} />
            <Route path={ROUTES.TOKEN} element={<TokenPage />} />
            <Route path={ROUTES.CORPORATE_INFO} element={<CorporateInfoPage />} />
            <Route path={ROUTES.WHITEPAPER} element={<WhitepaperPage />} />
            <Route path={ROUTES.AI_AUTOMATION} element={<AiAutomationPage />} />
            <Route path={ROUTES.ALGO_ENGINE_DASHBOARD} element={<AlgoEngineDashboardPage />} />
            <Route path={ROUTES.LINKTREE} element={<LinktreePage />} />
            <Route path={ROUTES.PRIVACY} element={<PrivacyPolicyPage />} />
            <Route path={ROUTES.COOKIE} element={<CookiePolicyPage />} />
            <Route path={ROUTES.TERMS} element={<TermsOfServicePage />} />
            <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
          </Routes>
        </main>
        {!isLinktreePage && <Footer />}
      </div>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <HashRouter>
          <AppContent />
        </HashRouter>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
